// The property types, as stored in a dynamic property's `type` field.
//
// This is the same set the backend knows (`AnyPropertyShape` in
// `functions/src/dyndata/shapes.ts`); keep the two in step. A stored type that
// isn't in it is dropped on load, with a warning, on both sides: by
// `conformDynamicProperties` (`functions/src/dyndata/fixups.ts`), the
// Firestore converter, on the backend, and by `DynamicGroup.setState` here.
//
// Only types that are actually in use are kept. A survey of the production
// database (backup of 2026-10-15) found no Select, Points, Position or None
// properties, so they were removed along with the never-initialized DEFAULT
// sentinel, rather than kept around looking like a compatibility promise.
// Select's one useful idea - restricting a Text to a list of values - lives on
// as Text's `enum` input hint, where the list comes from the editing context
// and never needs persisting.
//
// Does this module need to exist at runtime? Hydration doesn't need it:
// Group.create looks the stored `type` string up in the AllTypes registry
// directly. It is a convenience for client code, and the string lives in
// three places - a member here, an AllTypes key, and each class's `type`
// field. Only a string-literal union would erase entirely, at the cost of
// `DynamicPropertyType.ASSET` no longer being a value expression.
export enum DynamicPropertyType {
    ASSET = 'Asset',
    SVGText = 'SVGText',
    SVGData = 'SVGData',
    GROUP = 'Group',
    TEXT = 'Text',
    TEMPLATE = 'Template',
    COLOR = 'Color',
    NUMBER = 'Number',
    BOOLEAN = 'Boolean',
    DIMENSIONS = 'Dimensions',
    LABEL = 'Label',
    PERCENTAGE = 'Percentage',
    PIXELS = 'Pixels',
}
